import $axios from './index'
export function getdata(data) {
    const url = '/api/bi/sale_count/get_company_distribution'
    return $axios.get(url, data)
}
